import React, { ReactElement } from 'react';
import Paper from '@material-ui/core/Paper';
import { ClickAwayListener, Popper, Grow, PopperPlacementType } from '@material-ui/core';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import { useStyles } from './DropdownMenu.styles';

export interface MenuItemWithImage {
  text: string;
  disabled?: boolean;
  imagePath?: string;
  icon?: ReactElement;
  onClick?: () => void;
}

interface DropdownMenuProps {
  anchorEl: SVGSVGElement | undefined;
  setAnchorEl: (closeElement: SVGSVGElement | undefined) => void;
  menuItems?: string[];
  menuItemsWithImages?: MenuItemWithImage[];
  onClick: (item: string, menuItem?: MenuItemWithImage) => void;
  onClose?: () => void;
  disabled?: boolean;
  placement?: PopperPlacementType;
}

const DropdownMenu: React.FC<DropdownMenuProps> = (props) => {
  const classes = useStyles();
  const handleCloseMenu = () => {
    props.setAnchorEl(undefined);
    props.onClose && props.onClose();
  };

  return (
    <Popper
      className={classes.dropdownMenuExaminers}
      open={!!props.anchorEl}
      anchorEl={props.anchorEl}
      role={undefined}
      placement={props.placement ?? 'left'}
      transition
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper variant="elevation" elevation={4}>
            <ClickAwayListener onClickAway={handleCloseMenu}>
              <MenuList autoFocusItem={true} id="composition-menu" aria-label="composition-button">
                {props.menuItems &&
                  props.menuItems.map((item) => (
                    <MenuItem disableRipple disabled={props.disabled} key={item} onClick={() => props.onClick(item)}>
                      {item}
                    </MenuItem>
                  ))}
                {props.menuItemsWithImages &&
                  props.menuItemsWithImages.map((menuItem) => (
                    <MenuItem disableRipple
                      disabled={menuItem.disabled}
                      key={menuItem.text}
                      onClick={() => props.onClick(menuItem.text, menuItem)}
                    >
                      <div className={classes.itemRow}>
                        <div className={classes.iconCol}>
                          {menuItem.imagePath && <img src={menuItem.imagePath} alt='ikona opcji rozwijanego menu' />}{' '}
                          {menuItem.icon && <>{menuItem.icon}</>}
                        </div>
                        <div>{menuItem.text}</div>
                      </div>
                    </MenuItem>
                  ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default DropdownMenu;
